module.exports = __webpack_public_path__ + "img/amazon-logo.b8ad586d.png";